import cn from 'classnames';
import { FC } from 'react';

import Modal from '@components/ui/Modal/Modal';
import Text from '@components/ui/Text/Text';

import s from './ContentModal.module.scss';

interface Props {
  details?: string; // html string
  header?: string;
  open: boolean;
  onClose: () => void;
  contentSpacing?: 'gap' | 'min-height';
}

const ContentModal: FC<Props> = ({ details, header, open, onClose, contentSpacing = 'min-height' }) =>
  !!details && (
    <Modal
      className={s.modal}
      rootClassName={s.modalRoot}
      contentClassName={s.modalWrapper}
      open={open}
      onClose={onClose}
      closeOnClickOutside
    >
      {!!header && (
        <Text variant="header-5" className="text-center text-primary">
          {header}
        </Text>
      )}
      <div
        className={cn(s.modalContent, { [s.withGap]: contentSpacing === 'gap' })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: details }}
      />
    </Modal>
  );

export default ContentModal;
